import { NotifyHelper } from '../../../helpers/toast';
import { eThangDiemActionTypeDefine } from '../../action-types/IThangDiemActionType';
import { generateActionForKey, generateActions } from '../generateActions';

export const thangDiemActions = {
    ...generateActions(eThangDiemActionTypeDefine, "THANG_DIEM"),
    ...generateActionForKey(eThangDiemActionTypeDefine, "THANG_DIEM",
        "SAVE_SUCCESS", () => { NotifyHelper.Success("Saved") }
    ),
    ...generateActionForKey(eThangDiemActionTypeDefine, "THANG_DIEM",
        "DELETE_SUCCESS", () => { NotifyHelper.Success("Saved") }
    ),
    ...generateActionForKey(eThangDiemActionTypeDefine, "THANG_DIEM",
        "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }
    ),
    ...generateActionForKey(eThangDiemActionTypeDefine, "THANG_DIEM",
        "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }
    ),
}